export default __webpack_public_path__ + "ac326ba8746e5d2a1c96cfce6d47daca.svg";